import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
	TextField,
	withStyles,
	InputAdornment,
	Checkbox,
	LinearProgress,
	FormHelperText,
} from '@material-ui/core'
import { Email, Add, Phone } from '@material-ui/icons'
import Button from 'components/theme/Button'
import { handleFieldChange, handleAddField } from 'actions/contacts/addOrEdit'
import { createOrUpdateContact, toggleOptOut } from 'actions/contacts'
import classNames from 'classnames'
import language from 'utils/vast-languagepack'
import NumberFormatCustom from 'components/theme/NumberFormatCustom'

const AddButton = connect(null, (dispatch) =>
	bindActionCreators({ handleAddField }, dispatch),
)(({ handleAddField, field }) => (
	<Button
		color="secondary"
		variant="outlined"
		onClick={() => handleAddField(field)}
	>
		<Add />
		{language.contacts.add.newButton}
	</Button>
))

const Field = withRouter(
	connect(
		(state, { idx, fieldType }) => ({
			value: state.addOrEditContact.fields[fieldType][idx].value,
			initialValue: state.addOrEditContact.fields[fieldType][idx].initialValue,
			contactID: state.addOrEditContact.contactID,
			optIn: state.addOrEditContact.fields[fieldType][idx]['opt_in'],
			id: state.addOrEditContact.fields[fieldType][idx].id,
		}),
		(dispatch) =>
			bindActionCreators(
				{ handleFieldChange, createOrUpdateContact, toggleOptOut },
				dispatch,
			),
	)(
		withStyles((theme) => {
			const light = theme.palette.type === 'light'
			const bottomLineColor = light
				? 'rgba(0, 0, 0, 0.42)'
				: 'rgba(255, 255, 255, 0.7)'

			return {
				underline: {
					'&:before': {
						'@media (hover: none)': {
							borderBottom: `1px solid ${bottomLineColor}`,
						},
						borderBottom: 0,
					},
					'&:hover:not($disabled):not($focused):not($error):before': {
						borderBottom: `1px solid ${bottomLineColor}`,
					},
				},
				focused: {},
				disabled: {},
				error: {},
				icon: { color: theme.palette.secondary.main },
				strikethrough: { textDecoration: 'line-through' },
				root: { fontSize: 14 },
			}
		})(
			class Field2 extends Component {
				state = {
					typing: false,
					requesting: false,
				}

				// componentWillUnmount() {
				//   this.props.handleFieldChange(this.props.idx, '', this.props.fieldType)
				// }

				handleChange = (value) => {
					console.log('handleChange')
					// console.log(e)
					// console.log(e.target)
					// console.log(e.target.value)
					// console.log('handleChange')
					if (this.state.typing) {
						clearTimeout(this.timeout)
						this.props.handleFieldChange(
							this.props.idx,
							value,
							this.props.fieldType,
						)
						// this.setState({ typing: true })
						this.timeout = setTimeout(() => {
							this.setState({ requesting: true })
							this.props.createOrUpdateContact().then(
								(payload) => {
									this.setState({ requesting: false })
									if (
										this.props.history.location.pathname.slice(0, 13) ===
										'/contacts/new'
									) {
										this.props.history.replace(`/contacts/${payload.id}`)
									}
								},
								(err) => {
									this.setState({ requesting: false })
									return err
								},
							)
							this.setState({ typing: false })
						}, 500)
					}
				}

				render() {
					// console.log('Fields render()')
					const {
						value,
						classes,
						fieldType,
						optIn,
						id,
						toggleOptOut,
						idx,
						contactID,
					} = this.props

					const InputProps = {
						classes: {
							underline: classes.underline,
							root:
								optIn === false
									? classNames(classes.strikethrough, classes.root)
									: classes.root,
						},
						startAdornment: (
							<InputAdornment position="start">
								{fieldType === 'email' ? (
									<Email className={classes.icon} />
								) : (
									<Phone className={classes.icon} />
								)}
							</InputAdornment>
						),
						endAdornment: (
							<InputAdornment position="end">
								<Checkbox
									onChange={(e) => {
										if (contactID !== 'new') {
											toggleOptOut(
												contactID,
												fieldType,
												id,
												idx,
												e.target.checked ? 'optin' : 'optout',
											)
										}
									}}
									checked={optIn === true}
								/>
							</InputAdornment>
						),
					}

					return (
						<div>
							<TextField
								fullWidth
								placeholder={language.contacts.add.addNewText}
								InputProps={
									fieldType === 'phones'
										? { ...InputProps, inputComponent: NumberFormatCustom }
										: InputProps
								}
								onChange={(e) => this.handleChange(e.target.value)}
								// onKeyPress={() => {
								//   console.log('onKeyPress')
								// }}
								onKeyDown={() => this.setState({ typing: true })}
								value={value}
							/>
							{this.state.requesting ? (
								<LinearProgress color="secondary" />
							) : null}
						</div>
					)
				}
			},
		),
	),
)

export default connect(
	(state, { fieldType }) => ({
		list: state.addOrEditContact.fields[fieldType],
		error: state.addOrEditContact.fields[`${fieldType}Error`],
		// error: Object.keys(state.addOrEditContact.fields[`${fieldType}Error`]).join(
		// 	', ',
		// ),
	}),
	null,
)(({ list, classes, fieldType, error }) => (
	<div style={{ position: 'relative' }}>
		<FormHelperText error={Boolean(error)}>
			{Object.keys(error)
				?.map((err) => {
					if (err?.slice?.(0, 20) === 'should match pattern') {
						if (fieldType === 'email') {
							return 'should match pattern example@email.com'
						}
						if (fieldType === 'phones') {
							return 'should match pattern +1 (215) 999-9999'
						}
					}
					return err
				})
				?.join(', ')}
		</FormHelperText>
		<div
			style={{
				textAlign: 'right',
				color: 'rgba(0, 0, 0, 0.54)',
				fontSize: '1rem',
				display: fieldType === 'phones' ? 'none' : 'inline-block',
				position: 'absolute',
				width: '100%',
				top: '-15px',
			}}
		>
			{language.contacts.add.optInText}
		</div>
		<div style={{ marginBottom: 21 }}>
			{list.map((item, idx) => (
				<div
					style={{ marginBottom: 5 }}
					key={`addOrEditContactPage${fieldType}TextField${idx}`}
				>
					<Field fieldType={fieldType} idx={idx} />
				</div>
			))}
		</div>
		<AddButton field={fieldType} />
	</div>
))
